import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import PersonForm from "../../components/Persons/PersonsForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const PersonsEdit = ({classes, person, personType, uploadConfig, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('persons.edit_' + personType)}
        />

        <Card>
            <CardContent>
                <PersonForm
                    values={person}
                    formUrl={formUrl}
                    uploadConfig={uploadConfig}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default PersonsEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/persons/Edit.jsx